import React, { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import { Button } from "primereact/button";
import { uploadAttachment } from "src/actions/attachments";
import { getAttachmentList, deleteAttachment } from "src/actions/attachments";
import ToastMessage from "src/components/toast-message/ToastMessage";
import cookie from "react-cookies"

import {
  CCard,
  CRow,
  CCol,
  CCardBody,
  CCardHeader,
} from "@coreui/react";
import { getUserName } from "src/util/miscUtil";
import { globalApiUrl } from "src/util/globalUrls";


const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "black",
};

const rejectStyle = {
  borderColor: "red",
};

const Attachments = (props) => {
  const [files, setFiles] = useState([]);
  const id = props?.refId;
  const { type } = props
  const attType = type
  // const attachmentList = useSelector(
  //   (state) => state?.attachmentsReducer?.attachmentList
  // );
  const [attachmentList, setAttachmentList] = useState([])
  const uploadStatus = useSelector(
    (state) => state?.attachmentsReducer?.uploadStatus
  );
  const attDeleteStatus = useSelector(
    (state) => state?.attachmentsReducer?.attDeleteStatus
  );
  const [showType, setShowType] = useState("Upload");
  const [showAttToast, setShowAttToast] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      getAttachments(type, id);
    }
  }, [id])

  useEffect(() => {

    if (uploadStatus == 2) {
      setFiles([])
      getAttachments(type, id);
      setShowAttToast(true);
      setTimeout(() => {
        setShowAttToast(false);
      }, 1000);
      dispatch({
        type: "ATT_INIT_STATUS",
      });
    }
  }, [uploadStatus])

  useEffect(() => {
    if (attDeleteStatus == 2) {
      getAttachments(type, id)
    }
  }, [attDeleteStatus])

  const getAttachments = (type, id) => {
    fetch(globalApiUrl + `tallystaticreports/attachments/getAllAttachmentByRefIdAndType?type=${type}&refId=${id}`, {
      headers: {
        Tenant: cookie.load("TENANT"),
      },
    })
      .then((data) => data.json())
      .then((data) => {
        setAttachmentList(data)
      })
  }

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    // accept: "image/*",
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles);
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const renderFilesList = files.map((file) => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));

  const handleToggleClick = () => {
    showType == "Upload" ? setShowType("Table") : setShowType("Upload");
  }
  const viewAttachment = (data) => {
    window.open(globalApiUrl + "" + data.path)
  }

  const handleDelete = (data) => {
    dispatch(deleteAttachment(getUserName(), data.id));
  }

  const renderTableData = (val) => {
    return (
      val && val.length > 0 ? val.map((data) => {
        const arr = data.path.split('/')
        const attName = arr[arr.length - 1]
        return (
          <tr key={data.id}>
            <td>{attName}</td>
            <td>{data.type}</td>
            <td>
              <button type="button" className="btn btn-primary btn-sm mr-2 btn-shadow" onClick={() => viewAttachment(data)}><i className="fa fa-eye"></i></button>
              <button className="btn btn-danger btn-sm btn-shadow" type="button" onClick={() => handleDelete(data)}><i className="fa fa-trash"></i></button>
            </td>
          </tr>
        );
      }) :
        <tr>
          <td colSpan={6}> No data found :( </td>
        </tr>
    );
  };

  const handleFileSubmit = (type, refId) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append("type", type);
      formData.append("refId", refId);
      for (let f of files) {
        formData.append("files", f);
      }
      dispatch(uploadAttachment(formData));

    }
  };


  const attCompBody = (type) => {
    if (type == "Upload") {
      return (
        <>
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <p>Drag 'n' drop some files here, or click to select files</p>
          </div>
          <aside>
            <h4>Files</h4>
            <ul>{renderFilesList}</ul>
          </aside>
          <div className="mt-2 text-right">
            <button
              className="btn btn-success btn-md btn-shadow text-right"
              hidden={files.length == 0}
              onClick={() => handleFileSubmit(attType, id)}

            >
              Submit
            </button>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="card p-fluid border-0 ">
            <table className="table table-striped table-bordered credit-debit-table">
              <tbody>
                <tr>
                  <th>Attacment</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
                {renderTableData(attachmentList)}
              </tbody>
            </table>
          </div>
        </>
      );
    }
  }

  return (
    <>
      {showAttToast && (
        <ToastMessage
          severity="success"
          summary="Success"
          detail="Attachment(s) Saved Successfully"
        />
      )}
      <div>

        <div className="card-header light-card-header pl-3 pt-2 pb-2">
          <CRow>
            <CCol md="6 mt-1" xs="6">
              <h6 className="mb-0 head-bold"><i className="fas fa-paperclip"></i> Attachments</h6>
            </CCol>
            <CCol md="6" xs="6">
              <div className="float-right">
                <button onClick={() => { handleToggleClick() }}
                  label="Toggle"
                  className="btn btn-info btn-sm btn-shadow"
                ><i className={showType == "Upload" ? "fa fa-toggle-on" : "fa fa-toggle-off"} aria-hidden="true"></i> Toggle</button>
              </div>
            </CCol>
          </CRow>
        </div>
        <hr className="mt-0 mb-0 ml-3 mr-3 light-border" />
        <CCardBody className="attachment-inside">
          {attCompBody(showType)}
        </CCardBody>

      </div>
    </>
  )
};

export default Attachments;
